(function () {
  const sessionKey = 'rekal-general-modal-shown';

  function wasShown() {
    try {
      return window.sessionStorage.getItem(sessionKey) === 'true';
    } catch (error) {
      return false;
    }
  }

  function markAsShown() {
    try {
      window.sessionStorage.setItem(sessionKey, 'true');
    } catch (error) {
      // Continue without session persistence when storage is unavailable.
    }
  }

  function initModal(modal) {
    if (modal.dataset.generalModalInitialized === 'true') return;
    modal.dataset.generalModalInitialized = 'true';

    const delay = Number(modal.dataset.delay) || 0;
    const closeButtons = modal.querySelectorAll('[data-general-modal-close]');
    let timer;

    const close = () => {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('general-modal-open');
    };

    const open = () => {
      modal.style.removeProperty('visibility');
      modal.style.removeProperty('opacity');
      modal.style.removeProperty('pointer-events');
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('general-modal-open');

      if (modal.dataset.designMode !== 'true') markAsShown();
    };

    closeButtons.forEach((button) => button.addEventListener('click', close));

    if (modal.dataset.designMode === 'true') {
      open();
    } else if (wasShown()) {
      return;
    } else {
      timer = window.setTimeout(open, delay);
    }

    modal.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') close();
    });

    modal.addEventListener('click', (event) => {
      if (event.target === modal) close();
    });

    modal.addEventListener('shopify:section:unload', () => {
      window.clearTimeout(timer);
      close();
    });
  }

  function init() {
    document.querySelectorAll('[data-general-modal]').forEach(initModal);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
